<div class="min-w-[250px] px-4 sm:pl-7 h-full">
  <div class="flex flex-col h-full">
    <!-- Encabezado fijo -->
    <div class="w-full flex justify-between items-center mb-3 sticky top-0 bg-white z-10">
      <ion-label color="secondary" class="font-medium">{{ 'FILTERS.TITLE' | translate }}</ion-label>
      <ion-button color="secondary" mode="ios" fill="clear" class="filters-button clear" size="small" (click)="clearFilters()">
        <ion-label class="text-[12px] underline">{{ 'FILTERS.CLEAR_ALL' | translate }}</ion-label>
      </ion-button>
    </div>

    <!-- Mostrar mensaje de error para categorías si existe -->
    <div *ngIf="categoryError" class="filter-error-message">
      {{ categoryError }}
    </div>

    <!-- Mostrar mensaje de error para subcategorías si existe -->
    <div *ngIf="subcategoryError" class="filter-error-message">
      {{ subcategoryError }}
    </div>

    <!-- Contenedor con scroll -->
    <div class="filter-inputs-container">
  <ng-container *ngFor="let filter of filters; let i = index">
        <!-- Filtro de categoría con indicador de carga -->
        <div *ngIf="filter.id === 'category'" class="relative">
          <app-filter-input 
            color="secondary" 
            interface="popover" 
            [input]="filter"
            [value]="getFilterValue(filter.id)"
            [isWeb]="isWeb"
            (filterChange)="updateFilter($event)">
          </app-filter-input>

          <!-- Indicador de carga para categorías -->
          <div *ngIf="isLoadingCategories" class="filter-loading-spinner">
            <ion-spinner name="crescent" color="secondary" class="w-5 h-5"></ion-spinner>
          </div>
        </div>

        <!-- Filtro de subcategoría con indicador de carga -->
        <div *ngIf="filter.id === 'subcategory'" class="relative">
          <app-filter-input 
            color="secondary" 
            interface="popover" 
            [input]="filter"
            [value]="getFilterValue(filter.id)"
            [isWeb]="isWeb"
            (filterChange)="updateFilter($event)">
          </app-filter-input>

          <!-- Indicador de carga para subcategorías -->
          <div *ngIf="isLoadingSubcategories" class="filter-loading-spinner">
            <ion-spinner name="crescent" color="secondary" class="w-5 h-5"></ion-spinner>
          </div>
        </div>

  <!-- Start/End dates side-by-side when adjacent (only on non-web views) -->
  <div *ngIf="filter.id === 'startDate' && filters[i+1]?.id === 'endDate' && !isWeb" class="flex gap-2 items-stretch w-full">
          <div class="flex-1">
            <app-filter-input 
              color="secondary" 
              interface="popover" 
              [input]="filter"
              [value]="getFilterValue(filter.id)"
              [isWeb]="isWeb"
              (filterChange)="updateFilter($event)">
            </app-filter-input>
          </div>
          <div class="flex-1">
            <app-filter-input 
              color="secondary" 
              interface="popover" 
              [input]="filters[i+1]"
              [value]="getFilterValue(filters[i+1].id)"
              [isWeb]="isWeb"
              (filterChange)="updateFilter($event)">
            </app-filter-input>
          </div>
        </div>

        <!-- Otros filtros (skip endDate/startDate only when side-by-side grouping is active) -->
        <app-filter-input 
          *ngIf="filter.id !== 'category' && filter.id !== 'subcategory' && !(filter.id === 'endDate' && filters[i-1]?.id === 'startDate' && !isWeb) && !(filter.id === 'startDate' && filters[i+1]?.id === 'endDate' && !isWeb)"
          color="secondary" 
          interface="popover" 
          [input]="filter"
          [value]="getFilterValue(filter.id)"
          [isWeb]="isWeb"
          (filterChange)="updateFilter($event)">
        </app-filter-input>
      </ng-container>
    </div>

    <!-- Botón fijo en la parte inferior -->
    <ion-button mode="ios" color="secondary" class="w-full app-shadow fixed-height-btn" size="small" (click)="applyFilters()">
      {{ 'FILTERS.APPLY_FILTER' | translate }}
      <span *ngIf="activeFiltersCount > 0" class="filter-count-badge">
        {{ activeFiltersCount }}
      </span>
    </ion-button>
  </div>
</div>
